import React from 'react';
import { Box } from '@mui/material';

interface RegisterBackgroundProps {
  children: React.ReactNode;
}

const RegisterBackground: React.FC<RegisterBackgroundProps> = ({ children }) => {
  // Убираем скрол глобально для auth страниц
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100dvh',
        overflow: 'hidden',
        background: `url(/sign-up.webp)`,
        backgroundSize: 'auto 110%', // Твои 2K настройки
        backgroundPosition: 'right center', // Твои 2K настройки
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        // Сдвигаем картинку правее на меньших экранах чтобы не заезжала под форму
        '@media (max-width: 1800px)': {
          backgroundPosition: 'calc(100% + 150px) center',
        },
        '@media (max-width: 1600px)': {
          backgroundPosition: 'calc(100% + 250px) center',
        },
        '@media (max-width: 1400px)': {
          backgroundPosition: 'calc(100% + 350px) center',
        },
        // На 1200px и меньше - картинка по центру, форма по центру
        '@media (max-width: 1199px)': {
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            linear-gradient(90deg, #000000 0%, #000000 45%, rgba(0, 0, 0, 0.94) 60%, rgba(0, 0, 0, 0.75) 76%, rgba(0, 0, 0, 0.4) 88%, rgba(0, 0, 0, 0.6) 95%, rgba(0, 0, 0, 0.8) 100%),
            radial-gradient(ellipse 85% 45% at 90% 40%, transparent 25%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.4) 80%, rgba(0, 0, 0, 0.6) 98%, rgba(0, 0, 0, 0.7) 100%)
          `,
          zIndex: 1,
          // На 1200px и меньше - центральный оверлей для читаемости формы
          '@media (max-width: 1199px)': {
            background: `
              radial-gradient(ellipse 80% 80% at center, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.4) 100%)
            `,
          },
        },
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2, height: '100%' }}>
        {children}
      </Box>
    </Box>
  );
};

export default RegisterBackground;